import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import {
  createContext,
  FunctionComponent,
  ReactElement,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  // useLocation,
  useSearchParams,
} from "react-router-dom";

export const GetBulkRecordsContext = createContext(null);

type Props = {
  children: ReactElement;
};

const GetBulkRecordsProvider: FunctionComponent<Props> = ({ children }) => {
  const [queryParams, setQueryParams] = useSearchParams();
  // const { pathname } = useLocation();
  const pageQuery = queryParams.get("page") || 1;
  const tabQuery = queryParams.get("tab");

  const [pageNumber, setPageNumber] = useState(0);
  const [pageCount, setPageCount] = useState(0);

  // const path = pathname.includes("/app/back-office/screening-alert")
  //   ? "&status=COMPLETED"
  //   : "";

  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["bulk_records", pageQuery],
    staleTime: 30000,
    enabled: tabQuery === "bulk",
    queryFn: async () => {
      const url = `onboarding/bulk/records?page_size=10&page=${
        Number(pageQuery) - 1 + 1
      }`;
      const { data } = await Api.get(`${url}`);
      return data;
    },
  });

  useEffect(() => {
    if (data) {
      setPageCount(Math.ceil(data?.metadata.count / 10));
    }
  }, [data]);

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
      pageNumber,
      pageCount,
      setPageNumber,
      pageQuery,
      setQueryParams,
      error,
    }),
    [
      data,
      isLoading,
      isFetching,
      pageNumber,
      pageCount,
      setPageNumber,
      pageQuery,
      setQueryParams,
      error,
    ],
  );
  return (
    <GetBulkRecordsContext.Provider value={contextValue}>
      {children}
    </GetBulkRecordsContext.Provider>
  );
};

export default GetBulkRecordsProvider;
